import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import Award from 'www/vue_components/common/Award/components/common/Award.vue'
import { MOUNT_SELECTOR } from 'www/vue_components/common/Award/constants'

const mountElement = document.querySelector(MOUNT_SELECTOR)

if (mountElement) {
  new Vue({
    vuetify,
    el: MOUNT_SELECTOR,
    render: h => h(Award),
  })
}
